import { HttpErrorResponse } from '@angular/common/http';
import { createReducer } from '@ngrx/store';
import { OrderHistoryResponse } from '../../../shared/models/interfaces/orderHistoryResponse.interface';
import { orderHistoryReducers } from './order-history.reducer';

export interface AnalyticsState {
    ordersHistoryResponse: OrderHistoryResponse | null;
    loading: boolean;
    error: HttpErrorResponse | null;
    success: boolean;
}

export const initialState: AnalyticsState = {
    error: null,
    loading: false,
    ordersHistoryResponse: null,
    success: false,
};

export const analyticsReducer = createReducer(initialState, ...orderHistoryReducers);
